/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2022-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

import React, {useEffect, useState} from "react";
import {Link, useSearchParams} from 'react-router-dom';
import Helmet from "react-helmet";
import $ from "jquery";
import {actions, store} from '@corero/ssp-ui-components/stores/AuthStore';
import {actions as themeActions, store as themeStore} from "@corero/ssp-ui-components/stores/AppConfigStore"
import sharedConfig from '@corero/ssp-ui-components/core/sharedConfig';
import './ssoLogin.scss';


const SsoLogin = () => {
    const [titleTextColor, setTitleTextColor] = useState('');
    const [errorTextColor, setErrorTextColor] = useState('');
    const [loginColorText, setLoginTextColor] = useState('');
    const [searchParams] = useSearchParams();
    const [error, setError] = useState(searchParams.get('error'));

    const { username, csrfToken, csrfExpiry } = Object.fromEntries(searchParams);

    const onChange = () => {
        const currentStatus = store.getCurrentStatus();
        if (store.isAuth()) {
            window.location.href = window.location.origin + '/';
        } else if(currentStatus.success === false) {
            setError('1');
        }
    };

    const onThemeConfigChange = () => {
        setTitleTextColor(themeStore.getThemeConfiguration().login_title);
        setErrorTextColor(themeStore.getThemeConfiguration().login_color_error_text);
        setLoginTextColor(themeStore.getThemeConfiguration().login_color_text);
    }

    useEffect(() => {
        if (username && csrfToken && csrfExpiry) {
            actions.ssoLogin({
                username,
                csrfToken,
                csrfExpiry
            })
        }
    }, [username, csrfToken, csrfExpiry]);

    useEffect(() => {
        $("body").addClass("sso-login-page");
        $(".sso-login-page").css("background-image", "url(" + sharedConfig.apis.theme + "/backgroundImage)")
        store.addChangeListener(onChange);
        themeStore.addChangeListener(onThemeConfigChange)
        themeActions.fetchThemeConfiguration();
        return () => {
            store.removeChangeListener(onChange);
            $('.sso-login-page').css('background-image', '');
            $("body").removeClass("sso-login-page");
            themeStore.removeChangeListener(onThemeConfigChange)
        }
    // This effect only runs when the component is mounted
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="sso-login-container">
            <div className="sso-login-inner-container">
                <div className="col-sm-12">
                    <Helmet defer={false} title="SSO Login"/>
                    {error &&
                        <div role="alert" data-role="error">
                            <h1 style={{color: titleTextColor}} className="text-center">
                                We could not sign you in
                            </h1>
                            <p style={{color: errorTextColor}} className="sso-login-info mt20">
                                Please contact your administrator
                            </p>
                            <Link to={{pathname: `/login`}} className="sso-login-redirect mt40">
                                Click here to return to the login page
                            </Link>
                        </div>
                    }
                    {username && csrfToken && csrfExpiry && !error &&
                        <div role="alert" data-role="success">
                            <h1 style={{color: titleTextColor}} className="text-center">Logging you in</h1>
                            <p style={{color: loginColorText}} className="sso-login-info mt40">Please wait</p>
                        </div>
                    }
                </div>
            </div>
        </div>
    );

};

export default SsoLogin;
